module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "12px",
      "height": "11px",
      "viewBox": "0 0 12 11"
    }
  }, [_c('g', {
    attrs: {
      "id": "FINAL",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "pdf-fill-group",
    attrs: {
      "id": "Half-Caring-Adult",
      "transform": "translate(-649.000000, -769.000000)",
      "fill": "#51575D"
    }
  }, [_c('g', {
    attrs: {
      "id": "Download-PDF",
      "transform": "translate(649.000000, 762.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "download",
      "transform": "translate(0.000000, 7.000000)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "downlaod",
      "points": "12 5.07692308 8.57142857 5.07692308 8.57142857 0 3.42857143 0 3.42857143 5.07692308 0 5.07692308 6 11"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c48b6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/download.vue
// module id = 634
// module chunks = 1